/**
 * Estimateur Admin — même formule que backend/services/variableWeightPricing.js
 * (grammes × €/kg|100g). Ne jamais inverser poidsSouhaite/poidsReel.
 */

function roundMoney(n) {
  return Math.round((Number(n) || 0) * 100) / 100;
}

function normalizeUnitePoids(unitePoids) {
  const u = String(unitePoids || 'kg').toLowerCase().replace(/\s+/g, '');
  if (u === '100g' || u === '100gr' || u === '100grammes') return '100g';
  return 'kg';
}

export function calcPrixLigneAuPoidsAdmin({
  prixAuPoids,
  unitePoids,
  poidsGrammes,
  optionsExtra = 0,
}) {
  const poids = Number(poidsGrammes) || 0;
  const prixRef = Number(prixAuPoids) || 0;
  const unite = normalizeUnitePoids(unitePoids);
  const prixBase =
    unite === '100g'
      ? roundMoney(prixRef * (poids / 100))
      : roundMoney(prixRef * (poids / 1000));
  return roundMoney(prixBase + Number(optionsExtra || 0));
}

/**
 * @param {object} item — ligne commande Admin
 * @param {number|string} poidsGrammes — poids réel saisi (grammes)
 * @returns {number|null}
 */
export function estimerPrixDepuisPoids(item, poidsGrammes) {
  const poids = Number(poidsGrammes);
  if (!Number.isFinite(poids) || poids <= 0) return null;
  const prixAuPoids = Number(item?.produit?.prixAuPoids) || 0;
  if (!prixAuPoids) return null;
  const unite = item?.produit?.unitePoids || 'kg';
  const ancien = Number(item.prixFinal ?? item.prixTotal) || 0;
  // Après un 1er ajustement, le prix courant correspond au poidsReel — pas au souhaité.
  const poidsRef =
    Number(item.poidsReel) > 0
      ? Number(item.poidsReel)
      : Number(item.poidsSouhaite) || 0;
  let optionsExtra = 0;
  if (poidsRef > 0 && prixAuPoids > 0) {
    const baseRef = calcPrixLigneAuPoidsAdmin({
      prixAuPoids,
      unitePoids: unite,
      poidsGrammes: poidsRef,
      optionsExtra: 0,
    });
    optionsExtra = Math.max(0, roundMoney(ancien - baseRef));
  }
  return calcPrixLigneAuPoidsAdmin({
    prixAuPoids,
    unitePoids: unite,
    poidsGrammes: poids,
    optionsExtra,
  });
}
